module.exports = __webpack_public_path__ + "static/media/infoSvgNew.01480087.svg";